<template>
  <base-view title="Pedidos integrados - Anti fraude" class="mb-5 mr-4">
    <b-row class="mb-5">
      <b-col cols="12" class="mb-3">
        <div class="mb-2">Selecione o Anti fraude que deseja visualizar os pedidos:</div>
      </b-col>
      <b-col
        cols="12"
        class="d-flex align-items-center"
        v-if="loadingAntiFrauds"
      >
        <b-spinner small class="mr-2" /> Carregando AntiFrauds
      </b-col>
      <b-col cols="12" class="d-flex align-items-center">
        <AntiFraudSelectCard
          v-for="antiFraud in antiFrauds"
          :key="antiFraud.id"
          :antiFraud="antiFraud"
          :selected-anti-fraud="selectedAntiFraud || {}"
          @select="handleAntiFraudSelection(antiFraud)"
          class="mr-4"
        />
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      align-v="center"
      v-if="(selectedAntiFraud || {}).id"
    >
      <b-col v-if="Object.keys(selectedAntiFraud).length">
        <component :is="antiFraudIntegrationScreen" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
        class="d-flex flex-column align-items-center mb-4"
      >
        <b-spinner label="Spinning" class="mb-2"> </b-spinner>
        Carregando seus produtos...
      </b-col>
    </b-row>
  </base-view>
</template>

<script>
import { mapState } from 'vuex';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';

import EnabledIntegrationStatus from 'Enums/Integration/EnabledIntegrationStatus';
import IntegrationTypes from 'Enums/Integration/IntegrationTypes';

import AntiFraudSelectCard from './_components/AntiFraudSelectCard.vue';
import AntiFraudMapFolder from './_components/map-folder';

export default {
  name: 'AntiFraudIntegrateProducts',
  mixins: [makeToast],
  components: {
    AntiFraudSelectCard,
  },
  data() {
    return {
      EnabledIntegrationStatus,
      IntegrationTypes,
      loading: false,
      loadingAntiFrauds: false,
      selectedAntiFraud: {},
      antiFrauds: [],
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),

    antiFraudIntegrationScreen() {
      if (!this.selectedAntiFraud || !this.selectedAntiFraud.type) return;

      const folder = AntiFraudMapFolder[this.selectedAntiFraud.type];

      return () => import(`./_components/${folder}/ListOrders.vue`);
    },
  },
  mounted() {
    this.getAntiFrauds();
  },
  methods: {
    async getAntiFrauds() {
      this.loadingAntiFrauds = true;

      const { data } = await shopkeeperAppApi.get(
        `/integration/anti-fraud/${this.dadosUsuario.id}/integrations`
      );

      this.loadingAntiFrauds = false;

      this.antiFrauds = data.data || [];
    },
    handleAntiFraudSelection(antiFraud) {
      if (!antiFraud.enabledIntegration) return;

      if (
        antiFraud.enabledIntegration.status !== EnabledIntegrationStatus.ACTIVE
      )
        return;

      if (this.selectedAntiFraud.id === antiFraud.id) {
        this.selectedAntiFraud = {};
        return;
      }

      this.selectedAntiFraud = antiFraud;
    },
  },
};
</script>
